<template>
  <v-dialog scrollable v-model="viewDialog" persistent max-width="700">
    <v-card :loading="loading" loader-height="2">
      <v-card-title>{{ name }}</v-card-title>
      <v-card-text>
        <div class="mydata">
          <ul>
            <li>
              <div class="label">name</div>
              <div class="text">{{ view.name }}</div>
            </li>
            <li>
              <div class="label">version</div>
              <div class="text">{{ view.version }}</div>
            </li>
            <li>
              <div class="label">eml</div>
              <div class="text">{{ view.eml }}</div>
            </li>
            <li>
              <div class="label">formulations</div>
              <div class="text">{{ view.formulations }}</div>
            </li>
            <li>
              <div class="label">indications</div>
              <div class="text">{{ view.indications }}</div>
            </li>
            <li>
              <div class="label">ATC Codes</div>
              <div class="text">{{ view.atc_codes }}</div>
            </li>
            <li>
              <div class="label">combined</div>
              <div class="text">{{ view.combined }}</div>
            </li>
            <li>
              <div class="label">status</div>
              <div class="text">{{ view.status }}</div>
            </li>
            <li>
              <div class="label">local</div>
              <div class="text">{{ view.local }}</div>
            </li>
            <li>
              <div class="label">created</div>
              <div class="text">{{ view.created | myDating }}</div>
            </li>
          </ul>
        </div>
      </v-card-text>
      <v-card-actions>
        <span class="error_message">{{ responseMessage }}</span>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn small text color="red" v-on="on" @click="closeDialog">
              close
            </v-btn>
          </template>
          <span>cancel</span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Restful from "@/services/RestFul";
//   import moment from "moment";
//   import Utils from "./../../../../mixins/utils";
export default {
  props: {
    viewDialog: Boolean,
    myId: { type: Number, default: 0 },
    name: { type: String, default: null },
  },
  // mixins: [Utils],
  data() {
    return {
      loading: false,
      responseMessage: null,
      view: {},
    };
  },
  created() {
    this.find();
  },
  methods: {
    find() {
      this.loading = true;
      let self = this;
      Restful.general.medicines
        .find(this.myId)
        .then((response) => {
          console.log(response.data);
          this.view = response.data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error.response);
          self.loading = true;
        });
    },
    closeDialog() {
      let payload = { id: this.myId, state: false };
      this.$emit("closeView", payload);
    },
  },
};
</script>
